package io.github.dautovicharis.charts.app.ui.theme

/**
 * UI theme colors used to build the Material color scheme.
 */
data class Theme(
    val name: String,
    val light: UiColors,
    val dark: UiColors,
)
